"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconGoogle = void 0;
var React = __importStar(require("react"));
var IconGoogle = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M12.1201,18 C8.8281,18 6.1601,15.315 6.1601,12 C6.1601,8.686 8.8281,6 12.1201,6 C13.7301,6 15.0741,6.596 16.1061,7.564 L14.4261,9.255 L14.4261,9.252 C13.8011,8.651 13.0071,8.344 12.1201,8.344 C10.1531,8.344 8.5561,10.017 8.5561,11.997 C8.5561,13.976 10.1531,15.653 12.1201,15.653 C13.9051,15.653 15.1191,14.625 15.3691,13.215 L12.1201,13.215 L12.1201,10.875 L17.7261,10.875 C17.8021,11.276 17.8421,11.697 17.8421,12.136 C17.8421,15.562 15.5621,18 12.1201,18 M12.0001,2 C6.4771,2 2.0001,6.478 2.0001,12 C2.0001,17.522 6.4771,22 12.0001,22 C17.5221,22 22.0001,17.522 22.0001,12 C22.0001,6.478 17.5221,2 12.0001,2" }))); };
exports.IconGoogle = IconGoogle;
exports.IconGoogle.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconGoogle;
